import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Grid, Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { CustomerTitle, MainCustomerInfo, CustomerStatus } from "../../components/ui";
import { APIFunds } from "../../api";
import { fundedTraderActions } from "../../reducers/fundedTrader";

import * as Component from "./components";
import { FUNDS_API_URLS } from "../../api/funds";

const FundedTrader = (): React.ReactElement => {
  const params: { id: string } = useParams();
  const id = +params.id;
  const dispatch = useDispatch();

  const { isError, error } = useQuery({
    queryKey: [FUNDS_API_URLS.get_funded_trader_data, id],
    queryFn: async () => {
      dispatch(fundedTraderActions.dataFetchRequest());
      const response = await APIFunds.getFundedTraderDataRequest(id);
      dispatch(fundedTraderActions.dataFetchSuccess(response.data));
      return response.data;
    },
  });

  useEffect(() => {
    if (isError && error) {
      console.error("Error fetching funded trader data", error);
      dispatch(fundedTraderActions.dataFetchFailed());
    }
  }, [isError, error]);

  return (
    <CustomerStatus>
      <CustomerTitle />
      <MainCustomerInfo />

      <Box sx={{ mt: "20px" }}>
        <Grid container spacing={3}>
          <Grid item md={3}>
            <Component.UploadFilesGoogleDrive />
          </Grid>
        </Grid>
        <Box sx={{ mt: "20px" }}>
          <Component.DocumentDatesForm />
        </Box>
        <Grid container spacing={3}>
          <Grid item md={12}>
            <Component.PassesHistory />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ mt: "20px" }}>
        <Component.PreEnvoyData />
      </Box>
      <Box sx={{ mt: "20px" }}>
        <Component.TradedAccounts />
      </Box>
      <Box sx={{ mt: "20px" }}>
        <Component.WithdrawalRequestFormWithRequestsList />
      </Box>
    </CustomerStatus>
  );
};

export default FundedTrader;
